export default __webpack_public_path__ + "static/oil_collection_drum-ddf6f26e6fbb1bc058bffb0faa722f51.webp";